
export default function(dom, opts) {

	const wrapper = dom.querySelector('.header__wrapper');
	const scrolledClass = 'header--scrolled';
	const scrolledUpClass = 'header--scrolled-up';
	let scrollThreshold = 50;

	let scrolled = false;
	let scrolledUp = false;
	let scrollPos = window.scrollY;

	window.addEventListener('load', scrollHandler);
	window.addEventListener('scroll', scrollHandler);
	window.addEventListener('resize', scrollHandler);

	window.addEventListener('load', resizeHandler);
	window.addEventListener('resize', resizeHandler);

	function resizeHandler() {
		window.headerHeight = scrollThreshold = wrapper.clientHeight;
		document.documentElement.style.setProperty('--header-height', `${wrapper.clientHeight}px`);
	}

	function scrollHandler(e) {
		const bodyTop = document.body.getBoundingClientRect().top;
		const scrollTop = window.scrollY;

		if (scrollTop >= scrollThreshold) {
			dom.classList.add(scrolledClass);
			scrolled = true;

			if (bodyTop > scrollPos) {
				dom.classList.add(scrolledUpClass);
				scrolledUp = true;
			}
			else {
				dom.classList.remove(scrolledUpClass);
				scrolledUp = false;
			}
		}
		else {
			dom.classList.remove(scrolledClass);
			dom.classList.remove(scrolledUpClass);
			scrolled = false;
			scrolledUp = false;
		}

		scrollPos = bodyTop;
	}
}
